import {
  ChevronUp,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Card, message, Statistic, Cascader, Button, Input, Spin } from "antd";
import { fetchBrandsBySelectedClients } from "../../core/api/settings";
import ReactApexChart from "react-apexcharts";
import {
  processSales,
  getLastUploadDate,
  processYoungerSales,
} from "../../core/api/report";
import { SwapOutlined } from "@ant-design/icons";
import { getCurrentUser } from "../../core/api/settings";

const SalesByDate = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [brands, setBrands] = useState([]);
  const [lists, setLists] = useState([]);
  const [selectedLists, setSelectedLists] = useState([]);
  const [segments, setSegments] = useState([]);
  const [selectedSegments, setSelectedSegments] = useState([]);
  const [mailCodes, setMailCodes] = useState([]);
  const [selectedMailCodes, setSelectedMailCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const selectedClients = useSelector((state) => state.selectedClients);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingSalesData, setLoadingSalesData] = useState(false);
  const [historicalSalesData, setHistoricalSalesData] = useState([]);
  const [historicalSummary, setHistoricalSummary] = useState(null);
  const [before_100_mail_codes_count, setBefore_100_mail_codes_count] =
    useState(0);
  const [all_unique_mail_codes_count, setAll_unique_mail_codes_count] =
    useState(0);
  const [lastUpload, setLastUpload] = useState("");
  const [compareBrands, setCompareBrands] = useState([]);
  const [showCompareBox, setShowCompareBox] = useState(false);
  const [compareLists, setCompareLists] = useState([]);
  const [compareSegments, setCompareSegments] = useState([]);
  const [compareMailCodes, setCompareMailCodes] = useState([]);
  const [compareProducts, setCompareProducts] = useState([]);
  const [compareCategories, setCompareCategories] = useState([]);
  const [compareRor, setCompareRor] = useState(1);
  const [totalMailed, setTotalMailed] = useState(0);
  const [compareListOptions, setCompareListOptions] = useState([]);
  const [compareSegmentOptions, setCompareSegmentOptions] = useState([]);
  const [compareMailCodeOptions, setCompareMailCodeOptions] = useState([]);
  const [compareProductOptions, setCompareProductOptions] = useState([]);
  const [compareCategoryOptions, setCompareCategoryOptions] = useState([]);
  const [compareBrandOptions, setCompareBrandOptions] = useState([]);
  const [compareSalesData, setCompareSalesData] = useState([]);
  const [filteredYoungerThan100, setFilteredYoungerThan100] = useState({});
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(true);

  function predictSalesAdjusted(
    incompleteData,
    historicalData,
    targetTotalSales
  ) {
    if (!Array.isArray(incompleteData) || !Array.isArray(historicalData))
      return [];

    const lastKnownDay = incompleteData.findLastIndex(
      (d) => d.sales_percent > 0
    );
    if (lastKnownDay < 0) return [];

    const actualSalesSoFar = incompleteData
      .slice(0, lastKnownDay + 1)
      .reduce((sum, d) => sum + (d.sales_count || 0), 0);

    const expectedCumulativePercent =
      historicalData[lastKnownDay].sales_cumulative_percent;
    const expectedSalesSoFar =
      (expectedCumulativePercent / 100) * targetTotalSales;

    const performanceRatio =
      expectedSalesSoFar > 0 ? actualSalesSoFar / expectedSalesSoFar : 1;

    const predicted = incompleteData.map((entry, i) => {
      if (i <= lastKnownDay) return entry;

      const histDay = historicalData.find((d) => d.day === i);
      if (!histDay)
        return {
          ...entry,
          sales_count: 0,
          sales_percent: 0,
          sales_cumulative_percent:
            incompleteData[i - 1]?.sales_cumulative_percent || 0,
        };

      const adjustedSales = histDay.sales_percent * performanceRatio;
      const predictedCount = (adjustedSales / 100) * targetTotalSales;

      const prevCumulative =
        i > 0 ? incompleteData[i - 1].sales_cumulative_percent : 0;

      return {
        day: i,
        sales_count: Math.round(predictedCount),
        sales_percent: adjustedSales,
        sales_cumulative_percent: prevCumulative + adjustedSales,
      };
    });

    return predicted;
  }

  useEffect(() => {
    if (showCompareBox) {
      const fetchCompareSalesData = async () => {
        try {
          const res = await processYoungerSales(
            selectedClients,
            compareBrands,
            compareLists,
            compareSegments,
            compareMailCodes,
            compareProducts,
            compareCategories,
            compareRor
          );

          const {
            sales_data = [],
            filter_options = {},
            summary = {},
          } = res.data;
          const predData = predictSalesAdjusted(
            sales_data,
            historicalSalesData.data,
            112
          );
          const totalPredictedSalesCount = predData
            .slice(0, 101)
            .reduce((sum, item) => sum + (item.sales_count || 0), 0);
          setFilteredYoungerThan100(summary);
          setFilteredYoungerThan100((prev) => ({
            ...prev,
            predicted_sales_count: totalPredictedSalesCount,
          }));
          setCompareSalesData(predData);
          setCompareListOptions(filter_options.lists || []);
          setCompareSegmentOptions(filter_options.segments || []);
          setCompareMailCodeOptions(filter_options.mail_codes || []);
          setCompareProductOptions(filter_options.products || []);
          setCompareCategoryOptions(filter_options.categories || []);
        } catch (err) {
          console.error("Failed to fetch compare sales data", err);
          setCompareSalesData([]);
          setCompareListOptions([]);
          setCompareSegmentOptions([]);
          setCompareMailCodeOptions([]);
          setCompareProductOptions([]);
          setCompareCategoryOptions([]);
        }
      };
      fetchCompareSalesData();
    }
  }, [
    showCompareBox,
    compareBrands,
    compareLists,
    compareSegments,
    compareMailCodes,
    compareProducts,
    compareCategories,
    compareRor,
    historicalSalesData.data,
    selectedClients,
  ]);

  useEffect(() => {
    const fetchLastUploadDate = async () => {
      if (selectedBrands?.length === 1) {
        try {
          const dateResponse = await getLastUploadDate(selectedBrands[0]);
          if (dateResponse.data.last_upload_date) {
            const date = new Date(dateResponse.data.last_upload_date);
            const formattedDate = date.toLocaleString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            });
            setLastUpload(formattedDate);
          } else if (dateResponse.data.message) {
            setLastUpload(dateResponse.data.message);
          }
        } catch (error) {
          console.error("Error fetching last upload date:", error);
          setLastUpload("No sales data available for this brand");
        }
      }
    };
    fetchLastUploadDate();
  }, [selectedBrands]);

  const sLineSeries = [
    {
      name: "Historical Sales",
      data: historicalSalesData.data
        ? historicalSalesData.data.map((item) => item.sales_percent)
        : [],
      color: "blue",
    },
    {
      name: "Historical Cumulative Sales",
      data: historicalSalesData.data
        ? historicalSalesData.data.map((item) => item.sales_cumulative_percent)
        : [],
      color: "#006400",
    },
    {
      name: "Historical Refunds",
      data: historicalSalesData.data
        ? historicalSalesData.data.map((item) => item.refunds_percent)
        : [],
      color: "#FA8072",
    },
    {
      name: "Historical Cumulative Refunds",
      data: historicalSalesData.data
        ? historicalSalesData.data.map(
            (item) => item.refunds_cumulative_percent
          )
        : [],
      color: "#8B0000",
    },
    ...(compareSalesData.length > 0
      ? [
          {
            name: "Sales Percent",
            data: compareSalesData.map((item) => item.sales_percent),
            color: "blue",
            dashArray: 5,
          },
          {
            name: "Cumulative Sales Percent",
            data: compareSalesData.map((item) => item.sales_cumulative_percent),
            color: "#006400",
            dashArray: 5,
          },
        ]
      : []),
  ];

  const sLineArea = {
    chart: {
      type: "line",
      height: 350,
      zoom: {
        enabled: true,
      },
      toolbar: {
        tools: {
          download: false,
        },
      },
    },
    stroke: {
      width: 2,
      curve: "straight",
      dashArray: [0, 0, 0, 0, 8, 8, 8, 8],
    },
    xaxis: {
      categories: historicalSalesData.data?.map((item) => item.day) || [],
      title: {
        text: "Days",
      },
      labels: {
        rotate: -45,
      },
      scrollbar: {
        enabled: true,
      },
    },
    yaxis: {
      title: {
        text: "Percentage",
      },
      labels: {
        formatter: function (value) {
          return `${value.toFixed(0)}%`;
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      shared: true,
      intersect: false,
      followCursor: true,
      x: {
        formatter: (value) => `Day ${value}`,
      },
      y: {
        formatter: (value) => {
          if (value === undefined || value === null) return value;
          return `${value.toFixed(3)}%`;
        },
      },
    },
    noData: {
      text: loadingSalesData ? "Loading..." : "No Data present in the graph!",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Helvetica",
      },
    },
    title: {
      text: "Historical Trend",
      align: "center",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        fontFamily: undefined,
        color: "#263238",
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
    },
  };

  useEffect(() => {
    setLoadingBrands(true);
    setBrands([]);
    setSelectedBrands([]);
    fetchBrandsBySelectedClients(selectedClients)
      .then((res) => {
        if (!res.data || res.data.length === 0) return;

        setBrands(res.data);
        setCompareBrandOptions(res.data);
        if (res.data.length === 1) {
          const autoSelectedBrand = res.data[0].id;
          setSelectedBrands([autoSelectedBrand]);
          setCompareBrands([autoSelectedBrand]);
        }
        setLoadingBrands(false);
      })
      .catch(() => {
        setLoadingBrands(false);
        message.error("Failed to fetch brands.");
      });
  }, [selectedClients]);

  const fetchHistoricalSalesData = useCallback(async () => {
    setHistoricalSummary(null);
    setLoadingSalesData(true);
    try {
      const historicalResponse = await processSales(
        selectedClients,
        selectedBrands,
        selectedLists,
        selectedSegments,
        selectedMailCodes,
        selectedProducts,
        selectedCategories
      );
      setLists(historicalResponse.data.filter_options.lists);
      setSegments(historicalResponse.data.filter_options.segments);
      setMailCodes(historicalResponse.data.filter_options.mail_codes);
      setProducts(historicalResponse.data.filter_options.products || []);
      setCategories(historicalResponse.data.filter_options.categories || []);
      setBefore_100_mail_codes_count(
        historicalResponse.data.before_100_mail_codes_count
      );
      setAll_unique_mail_codes_count(
        historicalResponse.data.all_unique_mail_codes_count
      );

      setHistoricalSalesData({
        data: historicalResponse.data?.sales_data,
        brandId: selectedBrands,
      });
      setHistoricalSummary({
        summaryOlderThan100: historicalResponse.data?.summary_older_than_100,
        summaryOlderThan100ButNotWithin100Days:
          historicalResponse.data
            ?.summary_older_than_100_but_not_within_100_days,
        summaryOlderThan100AndWithin100Days:
          historicalResponse.data?.summary_older_than_100_and_within_100_days,
        summaryNotOlderThan100:
          historicalResponse.data?.summary_not_older_than_100,
        totalSalesSummary: historicalResponse.data?.total_sales_summary,
      });
      setCompareRor(historicalResponse.data?.rate_of_response || 1);
      setTotalMailed(historicalResponse.data?.total_mailed || 0);
    } catch (error) {
      message.error("Failed to process sales data.");
      console.error(error);
    } finally {
      setLoadingSalesData(false);
    }
  }, [
    selectedClients,
    selectedBrands,
    selectedLists,
    selectedSegments,
    selectedMailCodes,
    selectedProducts,
    selectedCategories
  ]);

  useEffect(() => {
    fetchHistoricalSalesData();
  }, [
    selectedClients,
    selectedBrands,
    selectedLists,
    selectedSegments,
    selectedMailCodes,
    selectedCategories,
    selectedProducts,
    fetchHistoricalSalesData
  ]);

  

  return (
    <div className="">
      <div className="">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Sales By Date</h4>
            </div>
          </div>

          <ul className="table-top-head">
            <li>
              <p className="text-gray-600 text-lg font-medium me-2">
                Last uploaded on:{" "}
                <span className="font-semibold text-gray-900">
                  {lastUpload}
                </span>
              </p>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Print </Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />{" "}
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Excel</Tooltip>}
              >
                <Link
                  onClick={() => {
                    // intentionally empty
                  }}
                >
                  <ImageWithBasePath src="assets/img/icons/xls.svg" alt="img" />{" "}
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Refresh</Tooltip>}
              >
                <Link
                  onClick={() => {
                    if (selectedBrands) fetchHistoricalSalesData();
                  }}
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Collapse</Tooltip>}
              >
                <Link
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
        </div>

        <div className="card table-list-card">
          <div className="card-body">
            <div
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: 3,
                marginBottom: 25,
                position: "relative",
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: -10,
                  left: "25%",
                  background: "#fff",
                  padding: "0 4px",
                  fontSize: 12,
                  color: "#555",
                }}
              >
                Filter Historical Trend
              </span>

              <Button
                type="default"
                size="small"
                icon={<SwapOutlined />}
                style={{ position: "absolute", bottom: -25, left: 0 }}
                onClick={() => setShowCompareBox(!showCompareBox)}
              >
                {showCompareBox ? "Stop Comparing" : "Compare"}
              </Button>

              <div className="d-flex flex-nowrap overflow-auto">
                <div className="p-2">
                  <span className="me-1 mt-1">Brand</span>
                  <Cascader
                    options={brands.map((brand) => ({
                      value: brand.id,
                      label: brand.brand_name,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedBrands}
                    onChange={setSelectedBrands}
                    loading={loadingBrands}
                  />
                </div>
                <div className="p-2">
                  <span className="me-1 mt-1">Mail Code</span>
                  <Cascader
                    options={mailCodes.map((code) => ({
                      value: code,
                      label: code,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedMailCodes}
                    onChange={setSelectedMailCodes}
                  />
                </div>
                <div className="p-2">
                  <span className="me-1 mt-1">Product</span>
                  <Cascader
                    options={products.map((prod) => ({
                      value: prod,
                      label: prod,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedProducts}
                    onChange={setSelectedProducts}
                  />
                </div>
                <div className="p-2">
                  <span className="me-1 mt-1">Category</span>
                  <Cascader
                    options={categories.map((cat) => ({
                      value: cat,
                      label: cat,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedCategories}
                    onChange={setSelectedCategories}
                  />
                </div>

                <div className="p-2">
                  <span className="me-1 mt-1">List</span>
                  <Cascader
                    options={lists.map((list) => ({
                      value: list,
                      label: list,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedLists}
                    onChange={setSelectedLists}
                  />
                </div>
                <div className="p-2">
                  <span className="me-1 mt-1">Segment</span>
                  <Cascader
                    options={segments.map((seg) => ({
                      value: seg,
                      label: seg,
                    }))}
                    placeholder="All"
                    multiple
                    showSearch
                    allowClear
                    value={selectedSegments}
                    onChange={setSelectedSegments}
                  />
                </div>
                <div className="p-2">
                  <span className="me-1 mt-1">RoR %</span>
                  <Input value={compareRor} style={{ width: 80 }} readOnly />
                </div>
              </div>
            </div>
            {showCompareBox && (
              <div
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: 3,
                  position: "relative",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: -10,
                    left: "25%",
                    background: "#fff",
                    padding: "0 4px",
                    fontSize: 12,
                    color: "#555",
                  }}
                >
                  Filter Campaigns Younger than 100 days
                </span>
                <div className="d-flex flex-nowrap overflow-auto">
                  <div className="p-2">
                    <span className="me-1 mt-1">Brand</span>
                    <Cascader
                      options={compareBrandOptions.map((brand) => ({
                        value: brand.id,
                        label: brand.brand_name,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareBrands}
                      onChange={setCompareBrands}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">Mail Code</span>
                    <Cascader
                      options={compareMailCodeOptions.map((code) => ({
                        value: code,
                        label: code,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareMailCodes}
                      onChange={setCompareMailCodes}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">Product</span>
                    <Cascader
                      options={compareProductOptions.map((prod) => ({
                        value: prod,
                        label: prod,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareProducts}
                      onChange={setCompareProducts}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">Category</span>
                    <Cascader
                      options={compareCategoryOptions.map((cat) => ({
                        value: cat,
                        label: cat,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareCategories}
                      onChange={setCompareCategories}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">List</span>
                    <Cascader
                      options={compareListOptions.map((list) => ({
                        value: list,
                        label: list,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareLists}
                      onChange={setCompareLists}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">Segment</span>
                    <Cascader
                      options={compareSegmentOptions.map((seg) => ({
                        value: seg,
                        label: seg,
                      }))}
                      placeholder="All"
                      multiple
                      showSearch
                      allowClear
                      value={compareSegments}
                      onChange={setCompareSegments}
                    />
                  </div>
                  <div className="p-2">
                    <span className="me-1 mt-1">P-RoR %</span>
                    <Input
                      value={(
                        (filteredYoungerThan100?.predicted_sales_count * 100) /
                        (filteredYoungerThan100?.total_mailed || 1)
                      ).toFixed(3)}
                      style={{ width: 80 }}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            )}

            <div id="s-line" style={{ position: "relative", minHeight: 450 }}>
              <Spin spinning={loadingSalesData} tip="Loading chart...">
                <ReactApexChart
                  options={sLineArea}
                  series={sLineSeries}
                  type="line"
                  height={450}
                />
              </Spin>
            </div>
          </div>
        </div>
        <div className="d-flex">
          <Card
            title="Filtered Historical Trend"
            size="small"
            className="me-2"
            loading={loadingSalesData}
            style={{ minWidth: "50%" }}
          >
            <div className="d-flex">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Metric</th>
                      <th>Sales</th>
                      <th>Refunds</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        label: "Campaigns Older than 100 Days",
                        data: historicalSummary?.summaryOlderThan100,
                      },
                      {
                        label:
                          "Campaigns Older than 100 Days but Not Within Last 100 Days",
                        data: historicalSummary?.summaryOlderThan100ButNotWithin100Days,
                      },
                      {
                        label:
                          "Campaigns Older than 100 Days and Within Last 100 Days",
                        data: historicalSummary?.summaryOlderThan100AndWithin100Days,
                      },
                      {
                        label: "Campaigns younger than 100 Days",
                        data: historicalSummary?.summaryNotOlderThan100,
                      },
                      {
                        label: "Total Summary",
                        data: historicalSummary?.totalSalesSummary,
                      },
                    ].map((item, index) => (
                      <tr key={index}>
                        <td>
                          <strong>{item.label}</strong>
                        </td>
                        <td>{item.data?.sales || 0}</td>
                        <td>{item.data?.refunds || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Card className="ms-2">
                <Statistic
                  title={"Compaigns Older than 100 Days"}
                  value={before_100_mail_codes_count || 0}
                  valueStyle={{ fontSize: "18px" }}
                />
                <Statistic
                  title={"Mailed in Campaigns Older than 100 Days"}
                  value={totalMailed || 0}
                  valueStyle={{ fontSize: "18px" }}
                />
                <Statistic
                  title={"Rate of Response"}
                  value={compareRor}
                  suffix={"%"}
                  valueStyle={{ fontSize: "18px" }}
                />
                <Statistic
                  title={"Compaigns Younger than 100 Days"}
                  value={
                    all_unique_mail_codes_count - before_100_mail_codes_count ||
                    0
                  }
                  valueStyle={{ fontSize: "18px" }}
                />
                <Statistic
                  title={"All Compaigns"}
                  value={all_unique_mail_codes_count || 0}
                  valueStyle={{ fontSize: "18px" }}
                />
              </Card>
            </div>
          </Card>
          <Card
            title="Filtered Campaigns Younger than 100 days trend"
            size="small"
            hidden={!showCompareBox}
            loading={showCompareBox && loadingSalesData}
          >
            <Card className="ms-2">
              <Statistic
                title={"Compaigns Count"}
                value={filteredYoungerThan100?.campaigns || 0}
                valueStyle={{ fontSize: "18px" }}
              />
              <Statistic
                title={"Total Mailed"}
                value={filteredYoungerThan100?.total_mailed || 0}
                valueStyle={{ fontSize: "18px" }}
              />
              <Statistic
                title={"Sales Count"}
                value={filteredYoungerThan100?.sales_count || 0}
                valueStyle={{ fontSize: "18px" }}
              />
              <Statistic
                title={"Rate of Response"}
                value={
                  (filteredYoungerThan100?.sales_count * 100) /
                  filteredYoungerThan100?.total_mailed
                }
                suffix={"%"}
                precision={3}
                valueStyle={{ fontSize: "18px" }}
              />
              <Statistic
                title={"Predicted Sales Count"}
                value={filteredYoungerThan100?.predicted_sales_count || 0}
                valueStyle={{ fontSize: "18px" }}
              />
              <Statistic
                title={"Predicted Rate of Response"}
                value={(
                  (filteredYoungerThan100?.predicted_sales_count * 100) /
                  (filteredYoungerThan100?.total_mailed || 1)
                ).toFixed(3)}
                suffix={"%"}
                valueStyle={{ fontSize: "18px" }}
              />
            </Card>
          </Card>
        </div>

        <Card
          title="Sales By Date Data"
          size="small"
          loading={loadingSalesData}
        >
          <div className="table-responsive small-font">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Metric</th>
                  {Array.from({ length: 101 }, (_, i) => (
                    <th key={i}>Day {i}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Historical Sales</td>
                  {historicalSalesData.data
                    ? historicalSalesData.data
                        .slice(0, 101)
                        .map((item, i) => (
                          <td key={i}>{item.sales_percent.toFixed(2)}%</td>
                        ))
                    : Array(101).fill(<td>—</td>)}
                </tr>
                <tr>
                  <td>Historical Cumulative Sales</td>
                  {historicalSalesData.data
                    ? historicalSalesData.data
                        .slice(0, 101)
                        .map((item, i) => (
                          <td key={i}>
                            {item.sales_cumulative_percent.toFixed(2)}%
                          </td>
                        ))
                    : Array(101).fill(<td>—</td>)}
                </tr>
                <tr>
                  <td>Historical Refunds</td>
                  {historicalSalesData.data
                    ? historicalSalesData.data
                        .slice(0, 101)
                        .map((item, i) => (
                          <td key={i}>{item.refunds_percent.toFixed(2)}%</td>
                        ))
                    : Array(101).fill(<td>—</td>)}
                </tr>
                <tr>
                  <td>Historical Cumulative Refunds</td>
                  {historicalSalesData.data
                    ? historicalSalesData.data
                        .slice(0, 101)
                        .map((item, i) => (
                          <td key={i}>
                            {item.refunds_cumulative_percent.toFixed(2)}%
                          </td>
                        ))
                    : Array(101).fill(<td>—</td>)}
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
        <br />
        <div style={{ height: 100 }}></div>
      </div>
    </div>
  );
};

export default SalesByDate;
